import { gql } from "@apollo/client";

export const BUTTON_RECORD = gql`
  fragment ButtonBlock on ButtonRecord {
    __typename
    id
    text
    link {
      __typename
      ... on PageRecord {
        id
        title
        slug
      }
      ... on ServiceRecord {
        id
        title
        slug
        parent {
          slug
        }
      }
      ... on ExpertiseRecord {
        id
        title
        slug
      }
      ... on TargetGroupRecord {
        id
        title
        slug
        parent {
          slug
        }
      }
      ... on ArticleRecord {
        id
        title
        slug
      }
      ... on OfficeRecord {
        id
        title
        slug
        parent {
          slug
          parent {
            slug
            parent {
              slug
              parent {
                slug
              }
            }
          }
        }
      }
      ... on MunicipalityRecord {
        id
        title
        slug
      }
      ... on AuditPageRecord {
        id
        title
        slug
      }
      ... on ServiceRecord {
        slug
        parent {
          slug
        }
      }
      ... on PageRecord {
        slug
      }
      ... on OfficeRecord {
        slug
        parent {
          slug
          parent {
            slug
            parent {
              slug
              parent {
                slug
              }
            }
          }
        }
      }
      ... on MunicipalityRecord {
        slug
      }
      ... on ExpertiseRecord {
        slug
      }
      ... on ContactRecord {
        slug
      }
      ... on ArticleRecord {
        slug
      }
      ... on TargetGroupRecord {
        slug
        parent {
          slug
        }
      }
      ... on AuditPageRecord {
        slug
      }
    }
    textual
    icon
    preIcon
    openLinkInNewTab
  }
`;

export const BUTTON_EXTERNAL_RECORD = gql`
  fragment ButtonExternalBlock on ButtonExternalRecord {
    id
    link
    text
    textual
    icon
    preIcon
    openLinkInNewTab
  }
`;

export const DOWNLOAD_BUTTON_RECORD = gql`
  fragment DownloadButtonBlock on DownloadButtonRecord {
    id
    requireEmail
    text
    file {
      id
      url
      filename
    }
    textual
    hubspotNewsletterSegment
  }
`;

export const HUBSPOT_BUTTON_RECORD = gql`
  fragment HubspotButtonBlock on HubspotButtonRecord {
    __typename
    id
    text
    hubspotCodeSnippet
    textual
    icon
    preIcon
  }
`;
